import { ClientSelection } from '../model';

export const hasSelections = <T extends ClientSelection, K extends keyof T>(obj: T, keys: K[]): obj is T & Required<Pick<T, K>> =>
  keys.every((key) => obj[key] !== undefined);
